module.exports = __webpack_public_path__ + "static/img/step-1.c0827bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/tuto-unlock-popup/firefox/step-1.png
// module id = bFU+
// module chunks = 1